<template>
    <icon-styled :size="size" :marginRight="marginRight" :name="name" :class="['icon', name, !isDot && 'dot']" />
</template>
<script>
import styled from "vue-styled-components";
import IconImage from "../assets/icon.png";

const props = {
    size: {
        type: Number,
        default: () => 2.4
    },

    marginRight: {
        type: Number,
        default: () => 1.8
    },

    name: String
};

// active color config to base.scss
const IconStyled = styled("div", props)`
    display: inline-block;
    width: ${props => props.size}rem;
    height: ${props => props.size}rem;
    margin-right: ${props => props.marginRight}rem;
    background-image: url(${IconImage});
    background-size: 300%;

    &.board {
        background-position-y: 0px;
    }

    &.notice {
        background-position-y: -${props => props.size * 10}px;
    }

    &.airplain {
        background-position-y: -${props => props.size * 10 * 2}px;
    }

    &.mill {
        background-position-y: -${props => props.size * 10 * 3}px;
    }

    &.heart {
        background-position-y: -${props => props.size * 10 * 4}px;
    }

    &.message {
        background-position-y: -${props => props.size * 10 * 5}px;

        &.dot {
            background-position-x: -48px;
        }
    }

    &.message_light {
        background-position-y: -${props => props.size * 10 * 6}px;

        &.dot {
            background-position-x: -24px;
        }
    }

    &.survey_light {
        background-position-y: -${props => props.size * 10 * 7}px;
    }

    &.share {
        background-position-y: -${props => props.size * 10 * 8}px;
    }
`;

export default {
    name: "Icon",
    props: {
        ...props,

        dot: {
            type: Boolean,
            default: () => true
        }
    },
    computed: {
        isDot() {
            return typeof this.dot === "boolean" ? this.dot : true;
        }
    },
    components: {
        IconStyled
    }
};
</script>
